import { render, staticRenderFns } from "./Epay.vue?vue&type=template&id=e45b01f6"
import script from "./Epay.vue?vue&type=script&lang=js"
export * from "./Epay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports